import { render, staticRenderFns } from "./VideoThumbnail.vue?vue&type=template&id=1a51fe1a&scoped=true&"
import script from "./VideoThumbnail.vue?vue&type=script&lang=ts&"
export * from "./VideoThumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./VideoThumbnail.vue?vue&type=style&index=0&id=1a51fe1a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a51fe1a",
  null
  
)

export default component.exports